import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ThemeModeContext } from '~theme-provider';
import { Row, Col } from '~layout';
import { AssetRenderer, TransitionItem, helpersPropTypes } from '~helpers';
import { LinkButton } from '~button';
import { typographyPropTypes } from '~typography';
import Main from './Main';
import ValueProposition from './ValueProposition';
import CallToActionList from './CallToActionList';
import siteLaunchTheme from '../../styles/siteLaunchTheme';
import siteLaunchPropTypes from '../../prop-types/siteLaunchPropTypes';

var SiteLaunch = function SiteLaunch(_ref) {
  var logoPath = _ref.logoPath,
      logoPathAlt = _ref.logoPathAlt,
      title = _ref.title,
      customTitle = _ref.customTitle,
      subtitle = _ref.subtitle,
      callToActions = _ref.callToActions,
      viewportHeight = _ref.viewportHeight,
      transitionTimeout = _ref.transitionTimeout,
      transitionType = _ref.transitionType,
      valuePropositionColor = _ref.valuePropositionColor,
      transitionOnEntered = _ref.transitionOnEntered,
      aside = _ref.aside,
      alignItems = _ref.alignItems;
  var theme = useContext(ThemeContext);

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  var logoWidth = _get(theme, 'siteLaunch.logo.width', siteLaunchTheme.siteLaunch.logo.width);

  var defaultColSize = 28;
  var colSize = {
    xxs: defaultColSize,
    xl: aside ? defaultColSize / 2 : defaultColSize
  };
  var transitionProps = {
    inProp: true,
    transitionType: transitionType,
    transitionTimeout: transitionTimeout,
    appear: true,
    onEntered: transitionOnEntered
  };
  return /*#__PURE__*/React.createElement(Main, {
    viewportHeight: viewportHeight
  }, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center",
    alignItems: alignItems
  }, /*#__PURE__*/React.createElement(Col, colSize, /*#__PURE__*/React.createElement(TransitionItem, transitionProps, logoPath && /*#__PURE__*/React.createElement(LinkButton, {
    to: "/",
    btnType: "link"
  }, /*#__PURE__*/React.createElement(AssetRenderer, {
    assetPath: themeMode === 'darkMode' ? logoPathAlt : logoPath,
    assetWidth: logoWidth
  })), /*#__PURE__*/React.createElement(ValueProposition, {
    title: title,
    customTitle: customTitle,
    subtitle: subtitle,
    color: valuePropositionColor
  }), /*#__PURE__*/React.createElement(CallToActionList, {
    list: callToActions
  }))), /*#__PURE__*/React.createElement(Col, colSize, aside && /*#__PURE__*/React.createElement(TransitionItem, transitionProps, aside))));
};

SiteLaunch.defaultProps = {
  logoPath: undefined,
  logoPathAlt: undefined,
  title: undefined,
  customTitle: undefined,
  subtitle: undefined,
  callToActions: undefined,
  viewportHeight: undefined,
  transitionType: 'fadeInFadeOut',
  transitionTimeout: {
    appear: 500,
    enter: 500
  },
  valuePropositionColor: undefined,
  transitionOnEntered: function transitionOnEntered() {},
  aside: undefined,
  alignItems: undefined
};
export default SiteLaunch;